import { getUrlBoolean } from '@/helpers/UrlParam';

const guidelines = getUrlBoolean('guidelines', false);

export const TheGuidelines = function () {
  return (
    <>
      {guidelines && (
        <div className={styles.guidelines}>
          <div className={cn(styles.guideline, styles.guidelineV)} />
          <div className={cn(styles.guideline, styles.guidelineH)} />
        </div>
      )}
    </>
  );
};
